import React, { forwardRef, useRef, useState } from 'react';
import PropTypes from "prop-types";

import ProfileLiveShowItem from './ProfileLiveShowItem';
import Slider              from '../../VXSlider/VXSlider';

import Flux            from '../../../flux/Flux';
import { generateKey } from '../../../utils/CommonUtils';
import { useEffect } from 'react';

const ProfileLiveShowSlider = forwardRef((props, ref) => {

    const {initIndex, data, isMobile, loadData } = props;

    const [currentIndex, setCurrentIndex]   = useState(initIndex);
    const [sliderWrapper, setSliderWrapper] = useState(null);

	const sliderWrapperRef = useRef(null);

	useEffect(() => {
		setSliderWrapper(sliderWrapperRef);
		ref.current = sliderWrapperRef;
	}, []);

    const onIndexChange = (currentIndex) => setCurrentIndex(currentIndex);

    const themeConfig = {
        showMessenger: !isMobile,
    };

    const content = data.map((item, index) => (
        <ProfileLiveShowItem
            key         = {generateKey(item.title[0].value, index)}
            activeItem  = {isMobile ? currentIndex === index : null}
            data        = {item}
            loadData    = {loadData}
            index       = {index}
            themeConfig = {themeConfig}
        />
    ));

    const challengeWrapper = (sliderWrapper?.current && !isMobile) ? sliderWrapper : null;

    return (
        <div ref = {sliderWrapperRef}>
             <Slider 
                initIndex        = {initIndex}
                onIndexChange    = {onIndexChange}
                sliderContent    = {content}
                challenges       = {[...content]}
                themeConfig      = {themeConfig}
                padding          = {isMobile ? 30 : null}
                gridGap          = {isMobile ? 30 : null}
                challengeWrapper = {challengeWrapper}

                mobileBreakpoint = {Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.sm}
                showControls     = {false}
                showArrows       = {!isMobile}
                isFullscreen     = {false}
            />
        </div>

    );
});

ProfileLiveShowSlider.propTypes = {
    data:            PropTypes.arrayOf(PropTypes.object),
    isMobile:        PropTypes.bool,
    loadData:        PropTypes.func,
    initIndex:       PropTypes.number,
    getWrapperWidth: PropTypes.func,
};

ProfileLiveShowSlider.defaultProps = {
    data:        [],
    isMobile:  false,
    initIndex: 0,
    loadData:  () => {},
};

export default ProfileLiveShowSlider;